module.exports = __webpack_public_path__ + "static/img/reset-password.965156da.png";